
<template>
    <component v-bind:is="transformed" :class="'vuetenberg-wysiwyg-content'"></component>
</template>

<script>
    import urlHelper from '../../utils/UrlHelper';
    import $ from 'jquery';

    export default {
        props: ['content'],
        mounted() {
          // Set on click listener on custom play overlay for embeded videos
          this.setupYoutubeVideo();
          this.setupEmbedVideo();
        },
        methods: {
            parseHtml(str) {
                const spanned = jQuery(`<div>${str}</div>`)
                spanned.find('a').attr('v-on:click', 'redirect($event)');
                const scripts = spanned.find('script');
                spanned.find('script').remove();
                return `<div>${spanned.html()}</div>`;
            },
            setupYoutubeVideo() {
              // Set on click listener on custom play overlay for embeded videos
              $(this.$el).find('.wp-block-embed').each(function () {
                const $this = $(this);
                const $iframe = $(this).find('iframe');
                $iframe.data('src', $iframe.attr('src'));
                $iframe.attr('src', '');
                const videoIdMatch = $iframe.data('src').match(/youtube\.com.*(\?v=|\/embed\/)(.{11})/);
                if (!videoIdMatch) {
                  return;
                }
                const videoId = videoIdMatch.pop();
                $this.css({'background-image': `url('//img.youtube.com/vi/${videoId}/0.jpg')`});
                $this.on('click', function () {
                  $this.addClass('wp-block-embed--start');
                  $iframe.attr('src', $iframe.data('src') + '&autoplay=true');
                });
              });
            },
            setupEmbedVideo() {
              $(this.$el).find('.wp-block-video').each(function () {
                const $this = $(this);
                $(this).click(function () {
                  const video = $this.find('video')[0];
                  if (!video) {
                    return;
                  }
                  video.play();
                  video.setAttribute('controls', 'controls')
                  $this.addClass('wp-block-video--running');
                });
              });
            },
        },
        computed: {
            transformed() {
                const template = this.parseHtml(this.content);
                return {
                    template: template,
                    props: this.$options.props,
                    methods: {
                        redirect(event) {
                            const vm = this;
                            let { href } = event.currentTarget || event.target;
                            if (urlHelper.isInternalLink(href)) {
                                const url = urlHelper.getUrl(href);
                                const link = vm.$router.resolve(url);
                                if (link && link.route.name !== 'notfound') {
                                  event.preventDefault();
                                  vm.$router.push( url );
                                }
                            }
                        }
                    }
                };
            }
        }
    };
</script>
